const configElement = document.getElementById( 'config' )
const configFromHtml = JSON.parse( configElement.innerHTML )
console.log('config', configFromHtml)
window.config24 = configFromHtml

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import Vue2TouchEvents from 'vue2-touch-events'
import vuexI18n from 'vuex-i18n'
import moment from 'vue-moment'
import VeeValidate from 'vee-validate'

import App from './App.vue'
import { routes } from './router/routes'
import { store } from './state/store'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import "vue-material-design-icons/styles.css"
import './assets/fonts/font-awesome/css/font-awesome.min.css'

import './pages/css/pages-icons.css'
import './pages/css/themes/light-cal.css'
// import './pages/css/themes/light.css'

import './assets/plugins/pace/pace-theme-flash.css'
import './assets/plugins/select2/css/select2.css'
import './assets/plugins/switchery/css/switchery.css'
// import './assets/css/24style.css'
// import './assets/css/24style-cal.css'
import './assets/css/24style-own.css'
import './assets/css/24style-cal-own.css'

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(Vue2TouchEvents)
Vue.use(moment)

Vue.use(vuexI18n.plugin, store,
  {
    moduleName: 'i18n',
    onTranslationNotFound (locale, key) {
      // console.warn(`i18n::Key '${key}' not found for locale '${locale}'`)
      return `***${key}***`
    },
  },
)

Vue.use(VeeValidate)

window.getBrowserLanguage = () => {
  let userLanguage = navigator.language
  if (userLanguage !== undefined) {
    let language = userLanguage.substring(0, 2)
    if (!(Vue.i18n.localeExists(language))) {
      return 'nl'
    }
    return language
  } else {
    return 'nl'
  }
}

store.state.currentLanguage = window.getBrowserLanguage()

Vue.http.options.root = window.config24.baseURL

// API translations
window.loadTranslation = (lang) => {
  Vue.http.get('i18n/' + lang).then(response => {
    Vue.i18n.add(lang, response.data)
  })
}

// Vue.i18n.add('en', translationsEn)
// Vue.i18n.add('nl', translationsNl)

export const router = new VueRouter({
  mode: 'history',
  routes
});

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

window.loadTranslation('en')
window.loadTranslation('nl')

Vue.i18n.set(window.getBrowserLanguage())

router.afterEach((to, from) => {
  store.state.sidebarOpen = false
  document.body.classList.remove('sidebar-open')
})



// WEBPACK FOOTER //
// ./src/main.js